<template>
	<div class="view-intermediary">
		<Modal
			:show="showIntermediary"
			content_class="col-12 col-md-10 col-lg-9 col-xl-7 confirm-modal"
		>
			<template slot="content" v-if="SelectedIntermediary">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								{{ SelectedIntermediary.intermediary_names }}
							</div>
						</div>
						<div class="close-modal f-r" @click="closeModal(1)">
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div class="top-info">
									<div class="header-info">
										<div class="intermediary-details">
											<div class="intermediary-logo-name">
												<img
													:src="
														SelectedIntermediary.logo_path
													"
													alt="Logo"
													class="logo-circle"
												/>
											</div>
											<div class="contact-info">
												<div class="details-grid">
													<div class="item">
														<strong>Name:</strong>
														<span>{{
															SelectedIntermediary.intermediary_names
														}}</span>
													</div>
													<div class="item">
														<strong
															>Category:</strong
														>
														<span>{{
															SelectedIntermediary.category
														}}</span>
													</div>
													<div class="item">
														<strong>Rating:</strong>
														<Rate
															v-model="
																SelectedIntermediary.rating
															"
															allow-half
															icon="fa fa-star"
															disabled
														/>
													</div>
													<div class="item">
														<strong
															>Contacts:</strong
														>
														<span>{{
															SelectedIntermediary
																.kyc[0].contacts
														}}</span>
													</div>
													<div class="item">
														<strong>Email:</strong>
														<span>{{
															SelectedIntermediary
																.kyc[0].emails
														}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="tab-box">
									<div class="tab-switch clearfix">
										<div
											class="tab f-l"
											:class="{ active: activeTab == 2 }"
											@click="openTab(2)"
										>
											About
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 4 }"
											@click="openTab(4)"
										>
											Quotation Requests
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 5 }"
											@click="openTab(5)"
										>
											Professions
										</div>
									</div>
									<div class="tab-content">
										<div
											class="content-1"
											v-show="activeTab == 2"
										>
											<div class="item padded">
												<strong>Description:</strong>
												<span
													class="desc font-sans px-2"
													>{{
														SelectedIntermediary
															.kyc[0].description
													}}</span
												>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 4"
										>
											<Dropdown
												class="fx-dropdown px-4 py-0 d-flex justify-content-start"
												trigger="click"
												@on-click="clickAction($event)"
											>
												<DropdownItem
													name="make_quotation_request"
												>
													<div class="clearfix">
														<i
															class="fab fa-wpforms"
														></i>
														<div class="menu-text">
															Make Quotation
															Request
														</div>
													</div>
												</DropdownItem>
											</Dropdown>
											<div
												class="quotation-request"
												v-if="
													quotation_requests &&
													quotation_requests.length >
														0
												"
											>
												<div
													class="card card-details"
													v-for="(
														request, i
													) in quotation_requests"
													:key="i"
													@click="
														fetchQuotationRecommendations(
															request,
														)
													"
													:class="{
														disabled:
															request.request_stage !==
															'CLIENT',
													}"
												>
													<div class="clearfix">
														<div class="status">
															{{
																request
																	.quotation_request_queue
																	.status_message
															}}
														</div>
														<div class="name">
															Created on:
															<b>{{
																moment(
																	request.request_date,
																).format(
																	'Do MMM YYYY HH:mm',
																)
															}}</b>
														</div>
														<div class="ref">
															{{
																request.system_quotation_request_ref
															}}
														</div>
														<div class="system">
															{{
																request.request_type
															}}
														</div>
														<div class="blue">
															Motor Vehicle
														</div>
														<div class="btn-bottom">
															<i
																class="fa fa-eye"
															></i>
														</div>
													</div>
												</div>
											</div>
											<div class="no-content" v-else>
												<div class="title">
													No Quotation Requests Found!
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 5"
										>
											<div
												class="proffesion"
												v-if="
													proffesions &&
													proffesions.length > 0
												"
											>
												<div
													class="card card-details"
													v-for="(
														proffesion, i
													) in proffesions"
													:key="i"
												>
													<div class="clearfix">
														<div
															class="f-l image-box"
														>
															<img
																v-if="
																	proffesion.icon
																"
																:src="
																	api.getDomain() +
																	proffesion.icon
																"
																alt=""
																class="avatar"
															/>
															<img
																v-else
																src="/img/avatars/2.png"
																alt=""
																class="avatar"
															/>
														</div>
														<div
															class="f-l text-box"
														>
															<div class="name">
																{{
																	proffesion.name
																}}
																-
																<span
																	class="tx-primary class"
																	>{{
																		proffesion.class_code
																	}}</span
																>
															</div>
															<div
																class="description"
															>
																{{
																	proffesion.description
																}}
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="no-content" v-else>
												<div class="title">
													No Professions Found!
												</div>
											</div>
										</div>
									</div>
								</div>
								<hr />
								<div class="actions-section">
									<button
										@click="
											clickAction(
												'make_quotation_request',
											)
										"
										class="btn btn-primary"
									>
										Request Quotation
									</button>
									<button
										@click="clickAction('book_appointment')"
										class="btn btn-secondary"
									>
										Book Meeting
									</button>
									<button
										@click="clickAction('chat')"
										class="btn btn-tertiary"
									>
										Contact Intermediaries
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showIntermediaryRequest"
			content_class="col-12 col-md-10 col-lg-9 col-xl-6 confirm-modal"
		>
			<template slot="content" v-if="SelectedIntermediary">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Request Quote</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit('showIntermediaryRequest', false)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="forms">
						<div class="page" v-if="intermediary_page == 1">
							<Form
								classBinding="row"
								:ref="Intermediary.forms.select_category.name"
								:forms="
									Intermediary.forms.select_category.forms
								"
								:form_data="
									Intermediary.forms.select_category.data
								"
							/>

							<div
								class="btn btn-long btn-primary"
								@click="
									selectProductCatalogue({
										ref: $refs[
											Intermediary.forms.select_category
												.name
										],
									})
								"
								:disabled="loading"
							>
								Next
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
						<div class="page" v-if="intermediary_page == 2">
							{{}}
							<div
								class="step"
								v-if="request_type === 'customized'"
							>
								<div class="forms">
									<Form
										classBinding="row"
										:ref="
											intermediary_requirement_fields.name
										"
										:forms="
											intermediary_requirement_fields.forms
										"
										:form_data="
											intermediary_requirement_fields.data
										"
										@file-selected="uploadFiles"
									/>
								</div>

								<div
									class="btn btn-long btn-primary"
									@click="
										setCustomizedProductForms({
											ref: $refs[
												intermediary_requirement_fields
													.name
											],
										})
									"
									:disabled="loading"
								>
									Next
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
							<div class="step" v-if="request_type === 'free'">
								<Form
									classBinding="row"
									:ref="Intermediary.forms.request_quote.name"
									:forms="
										Intermediary.forms.request_quote.forms
									"
									:form_data="
										Intermediary.forms.request_quote.data
									"
									@file-selected="uploadFilesIntermediary"
								/>

								<div
									class="btn btn-long btn-primary"
									@click="
										setFreeProductForms({
											ref: $refs[
												Intermediary.forms.request_quote
													.name
											],
										})
									"
									:disabled="loading"
								>
									Next
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
						<div class="page" v-if="intermediary_page == 3">
							<Form
								classBinding="row"
								:ref="Intermediary.forms.accept_terms.name"
								:forms="Intermediary.forms.accept_terms.forms"
								:form_data="
									Intermediary.forms.accept_terms.data
								"
							/>

							<div
								class="btn btn-long btn-primary"
								@click="
									requestQuote({
										ref: $refs[
											Intermediary.forms.accept_terms.name
										],
									})
								"
								:disabled="loading"
							>
								Make A Request
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showAppointmentForm"
			content_class="col-12 col-md-10 col-lg-9 col-xl-6 confirm-modal"
		>
			<template slot="content" v-if="SelectedIntermediary">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Book an appointment</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showAppointmentForm', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="forms">
						<div class="page">
							<Form
								classBinding="row"
								:ref="Intermediary.forms.appointment_form.name"
								:forms="
									Intermediary.forms.appointment_form.forms
								"
								:form_data="
									Intermediary.forms.appointment_form.data
								"
							/>

							<div
								class="btn btn-long btn-primary"
								@click="
									makeAnAppointment({
										ref: $refs[
											Intermediary.forms.appointment_form
												.name
										],
									})
								"
								:disabled="loading"
							>
								Book Appointment
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showChatUsers"
			content_class="col-12 col-md-10 col-lg-9 col-xl-6 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Chat with User</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showChatUsers', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="forms">
						<div class="page">
							<Form
								classBinding="row"
								:ref="Intermediary.forms.chat_users.name"
								:forms="Intermediary.forms.chat_users.forms"
								:form_data="Intermediary.forms.chat_users.data"
							/>

							<div
								class="btn btn-long btn-primary"
								@click="
									goToChat({
										ref: $refs[
											Intermediary.forms.chat_users.name
										],
										router: $router,
									})
								"
								:disabled="loading"
							>
								Chat Now
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<AddReview />
		<ShowReviews title="Intermediary Reviews" />
		<Recommendation />
	</div>
</template>

<script>
export default {
	components: {
		AddReview: () => import('../templates/others/review'),
		Recommendation: () => import('./recommendations'),
		ShowReviews: () => import('../templates/others/list-reviews'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
		Rate: () => import('@/libs/clarks/components/rate/index'),
		Modal: () => import('../templates/others/modal'),
		Form: () => import('@/libs/clarks/components/form'),
		products: [],
	},
	computed: {
		...mapGetters([
			'appointments',
			'showAppointmentForm',
			'showIntermediary',
			'showChatUsers',
			'showIntermediaryRequest',
			'SelectedIntermediary',
			'quotation_requests',
			'intermediary_requirement_fields',
			'activeTab',
			'loading',
			'proffesions',
			'intermediary_page',
			'request_type',
			'Intermediary',
		]),
	},
	data() {
		return {
			moment,
			api,
		};
	},
	methods: {
		...mapActions([
			'fetchData',
			'closeModal',
			'openModal',
			'openTab',
			'makeAnAppointment',
			'goToChat',
			'requestQuote',
			'selectProductCatalogue',
			'fetchQuotationRecommendations',
			'uploadFilesIntermediary',
			'uploadFiles',
			'fetchIntermediaryChatUsers',
			'setFreeProductForms',
			'setCustomizedProductForms',
			'fetchProductCatalogue',
			'fetchProductReviews',
			'fetchRecommendations',
			'rejectAppointment',
			'acceptAppointment',
		]),
		async clickAction(action) {
			switch (action) {
				case 'list_reviews':
					await this.fetchProductReviews();
					this.$store.commit('showListReview', true);
					Event.$emit('loader:show', false);
					break;
				// case 'quotation_recomendations':
				//    await this.fetchRecommendations(),
				//    this.$store.commit('showRecommendations',true)
				//    break;
				case 'add_review':
					this.$store.commit('showAddReviews', true);
					break;
				case 'book_appointment':
					this.$store.commit('showAppointmentForm', true);
					break;
				case 'make_quotation_request':
					// await this.fetchProductCatalogue()
					this.$store.commit('intermediary_page', 1);
					this.$store.commit('showIntermediaryRequest', true);
					break;
				case 'chat':
					await this.fetchIntermediaryChatUsers();
					this.$store.commit('showChatUsers', true);
					break;
				default:
					break;
			}
		},
		close() {
			Event.$emit('filter:close', { filter: false });
		},
		toggleFilter() {},
	},
	mounted() {},
};
</script>

<style lang="less">
.view-intermediary {
	.quotation-request {
		cursor: pointer;

		.system {
			color: #a7abbd;
			font-size: 13px;
			font-weight: 600;
			text-transform: uppercase;
		}
		.status {
			text-align: right;
			font-size: 12px;
			font-weight: 600;
			text-transform: uppercase;
			color: var(--ne-green);
		}
		.ref {
			font-size: 17px;
			color: var(--text-color);
			font-family: var(--font-bold);
			line-height: 15px;
			text-transform: uppercase;
		}
		.blue {
			font-weight: 600;
			color: #9c7bfc;
			font-size: 13px;
		}
		.btn-bottom {
			margin: 3px 0 0 0;
			text-align: right;

			i:hover {
				display: block;
				color: var(--ne-blue);
			}
		}
		.name {
			font-size: 13px;
			margin: 2px 5px 5px 0;
		}

		.card.disabled {
			cursor: not-allowed !important;

			.status {
				color: var(--ne-red);
			}

			i {
				display: none;
			}
		}
	}
	.proffesion {
		.name {
			font-weight: 600;
			font-size: 14px;

			.class {
				text-transform: uppercase;
				font-size: 13px;
			}
		}

		.description {
			font-size: 14px;
		}

		.image-box {
			width: 100px;
			max-height: 150px;
			text-align: center;
			margin: 0 20px 0 0;

			img {
				width: auto;
				height: auto;
				max-width: 100%;
				max-height: 100%;
			}
		}
		.text-box {
			float: left;
			width: calc(100% - 150px) !important;
		}
	}
	.appointment {
		.card {
			margin: 5px 10px !important;

			.subject {
				font-size: 13px;
				color: var(--primary);
				font-weight: 600;
			}
			.description {
				font-size: 13px;
			}
			.date {
				color: var(--ne-red);
				font-weight: 600;
				font-size: 14px;
				text-align: right;
			}
		}
	}
	.no-padding {
		margin: 20px -30px !important;
	}
	.top-info {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px;
		background-color: #f8f9fa; /* A light background for the info section */
		border-bottom: 1px solid #e6eaee;
	}
	.header-info {
		width: 100%;
	}
	.intermediary-details {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;

		.intermediary-logo-name {
			flex-shrink: 0;
			margin-right: 20px;

			.logo-circle {
				width: 60px;
				height: 60px;
				border-radius: 50%;
				object-fit: cover;
			}
		}
		.contact-info {
			flex-grow: 1;
			.details-grid {
				display: grid;
				grid-template-columns: auto 1fr;
				gap: 5px 10px;
				align-items: center;
				.item {
					display: contents;
					strong {
						font-weight: 600;
						text-align: left;
					}
					span,
					.ivu-rate {
						text-align: right;
						justify-self: end;
					}
				}
			}
		}
	}
	.intermediary {
		margin: 30px 0;
	}
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}

	.content-section {
		padding: 20px 0;

		h3 {
			font-size: 20px;
			margin-bottom: 15px;
			color: var(--primary);
		}

		.item {
			display: block;
			margin-bottom: 10px;

			strong {
				font-weight: 600;
			}
			.desc {
				display: inline-block;
				max-width: 100%;
				overflow-wrap: break-word;
			}
		}
	}

	.actions-section {
		display: flex;
		justify-content: space-around;
		padding: 20px 0;
		border-top: 1px solid #e6eaee;

		.btn {
			padding: 10px 20px;
			border: none;
			border-radius: 5px;
			font-weight: bold;
			cursor: pointer;
			transition: background-color 0.3s ease;

			&.btn-primary {
				background-color: var(--ne-blue);
				color: white;
				&:hover {
					background-color: #2e6da4;
				}
			}
			&.btn-secondary {
				background-color: #f0f0f0;
				color: #333;
				&:hover {
					background-color: #e0e0e0;
				}
			}
			&.btn-tertiary {
				background-color: var(--ne-red);
				color: white;
				&:hover {
					background-color: #a94442;
				}
			}
		}
	}
}
</style>
